module.exports = __webpack_public_path__ + "static/media/our-team.65e8c4bb.jpg";